module.exports = __webpack_public_path__ + "static/media/home-caro-3.1cb79e9b.png";